// base
import React, { useEffect, useMemo, useRef } from 'react';

// libraries
import gsap from 'gsap';
import { useGLTF } from '@react-three/drei';
import { SkeletonUtils } from 'three-stdlib';
import { useGraph } from '@react-three/fiber';

useGLTF.preload('/assets/models/icons/stickey_note/Stickey_Note.glb');

export const StickeyNote = (props) => {
  const { position, scale = 3 } = props;

  const noteRef = useRef();

  const { scene } = useMemo(
    () => useGLTF('/assets/models/icons/stickey_note/Stickey_Note.glb'),
    []
  );

  const clone = useMemo(() => SkeletonUtils.clone(scene), [scene]);
  const { nodes, materials } = useGraph(clone);

  useEffect(() => {
    scene.traverse((mesh) => {
      mesh.castShadow = true;
      mesh.receiveShadow = true;

      if (mesh.material) {
        mesh.material.emissive = { r: 0.5, g: 0.5, b: 0 };
        mesh.material.emissiveIntensity = 0.2;
      }
    });

    if (!noteRef.current) return;

    const rotationTween = gsap.to(noteRef.current.rotation, {
      duration: 3,
      repeat: -1,
      yoyo: false,
      ease: 'none',
      y: Math.PI * 2
    });

    return () => {
      rotationTween.kill();
    };
  }, []);

  return (
    <group ref={noteRef} position={position} dispose={null} scale={scale} name="stickey_note">
      <mesh
        geometry={nodes.Plane002.geometry}
        material={materials.Blue}
        position={[0.033, -0.373, -0.281]}
        rotation={[2.79, 0.587, 0.183]}
        scale={-3.595}
      />
      <mesh
        geometry={nodes.Plane001.geometry}
        material={materials.Red}
        position={[0.018, -0.232, -0.127]}
        rotation={[2.781, 0.582, 0.199]}
        scale={-3.595}
      />
      <mesh
        geometry={nodes.Plane.geometry}
        material={materials['Yellow Note']}
        position={[-0.007, -0.166, -0.126]}
        rotation={[2.778, 0.58, 0.205]}
        scale={-3.595}
      />
      <mesh
        geometry={nodes.Circle.geometry}
        material={materials.Red}
        position={[0.808, 1.369, 0.608]}
        rotation={[-1.981, 0.957, -0.735]}
        scale={[-0.157, -0.115, -0.157]}
      >
        <mesh
          geometry={nodes.Circle001.geometry}
          material={materials.silver}
          position={[0.006, -5.605, 0]}
          scale={[0.894, 0.909, 0.894]}
        />
      </mesh>
    </group>
  );
};
